export const apiEndpoints = {
    country: '/country',
};

export default apiEndpoints;
